module.exports = __webpack_public_path__ + "static/img/Andrew-Gaff.460348e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Andrew-Gaff.jpg
// module id = EY5G
// module chunks = 0